import {
  Offcanvas,
} from "react-bootstrap";
import BlogPostPreview from "./BlogPostPreview";

const PostDetails = ({ postData, show, hide }) => {
  return (
    <Offcanvas show={show} onHide={hide} placement="end" style={{width: 600}}>
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>{postData?.title}</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body className="p-0">
        <BlogPostPreview postId={postData?.postId} />
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default PostDetails;
